import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { IdentityService } from './identity.service';
import { AdminRole } from './models/admin-user-info';

export function roleGuard(...allowedRoles: AdminRole[]): CanActivateFn {
    return () => {
        const identityService = inject(IdentityService);
        const router = inject(Router);

        return identityService.stateChanges.pipe(
            take(1),
            map(state => {
                if (state.user && allowedRoles.includes(state.user.role)) {
                    return true;
                }
                return router.createUrlTree(['/']);
            }),
        );
    };
}
